/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Apr 17 2024
 **/

import { initializeApp } from "firebase/app";
import { OAuthProvider, getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";
import { atom } from "jotai";

export type FirebaseState = {
	googleProvider: OAuthProvider;
	appleProvider: OAuthProvider;
	auth: ReturnType<typeof getAuth>;
	messaging: ReturnType<typeof getMessaging>;
	firebaseApp: ReturnType<typeof initializeApp>;
};

export const FirebaseStateAtom = atom<FirebaseState | null>(null);
